export class ApiTokenDto {
    id!: string;   
    creator_Id!: string;
    creator_Name!: string;
    id_created_When!:string;
    valid_Until!:string;
    user_Id!:string;
    user_Name!:string;
    user_Email!:string;
    tenant_Name!:string;
    additional_Data!:string;
}